export const formatMoney = (value?: number, placeHolderIfNull = ' - ') =>
  value === undefined
    ? placeHolderIfNull
    : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'brl' }).format(value)
